module.exports = __webpack_public_path__ + "prod/1.42.2/img/service-3.b73909e5.png";